import { atom, useRecoilState } from 'recoil';
import { AuthState, AuthUser, UseAuthState } from './auth.types';

export const authState = atom<AuthState>({
  default: {
    isAuthenticated: false,
    user: undefined,
  },
  key: 'authState',
});

export const useAuthState = (): UseAuthState => {
  const [state, setState] = useRecoilState(authState);

  return {
    ...state,
    onLogout: () => setState({ isAuthenticated: false, user: undefined }),
    onSignInSuccess: (user: AuthUser) => setState({ isAuthenticated: true, user }),
  } as UseAuthState;
};
